
  import Vue from 'vue';
  import Component from 'vue-class-component';
  import {inProgressChallengesModule, inProgressChallengesState} from '@/utils/store-acessor';
  import {ChallengeModel} from '@/models/challenge.model';
  import ChallengesSituationsTemplate from '@/components/Challenges/ChallengesSituationsTemplate.vue';

  @Component({
    components: {
      ChallengesSituationsTemplate,
    },
  })
  export default class ChallengeInProgress extends Vue {
    @inProgressChallengesModule.Getter('challenges') challenges!: ChallengeModel[];
    @inProgressChallengesModule.Getter('lastPage') lastPage!: number;
    @inProgressChallengesModule.Getter('currentPage') page!: number;
    @inProgressChallengesModule.Getter('loading') loading!: boolean;
    @inProgressChallengesModule.Getter('challengesByTag') challengesByTag!: (tag: string) => ChallengeModel[];

    get tag(): string | null {
      return this.$route.query?.tag?.toString() || null
    }

    get emptyMessage(): string {
      return !!this.tag ? this.$t('challenge.labels.no_challenges_in_progress_with_tag', [this.tag]).toString() : this.$t('challenge.labels.no_challenges_in_progress').toString();
    }

    get challengesFiltered(): ChallengeModel[] {
      if (this.tag) {
        return this.challengesByTag(this.tag)
      }
      return this.challenges
    }


    async mounted() {
      this.makeRequest(1)
    }

    async inBottom() {
      if ((this.page < this.lastPage) && !this.loading) {
        this.makeRequest(1)
      }
    }

    private async makeRequest(page: number = 1) {
      const tag = this.$route.query?.tag?.toString()
      await inProgressChallengesState.fetchAll({
        page,
        tag
      });
    }
  }

